// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.upload-demo{\r\n  margin:0 auto;\r\n  width:100%;\n}\n.tips{\r\n  padding:10px;\r\n  text-align: center;\n}\r\n", ""]);
// Exports
module.exports = exports;
